module.exports = __webpack_public_path__ + "static/media/android-play-en.519564cd.svg";